import { ReviewPlatform } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

// Flip this to false to enable the Review Analysis page
export const REVIEW_ANALYSIS_DISABLED = false

// Human-readable platform names, shared across review-analysis widgets.
export const PLATFORM_LABEL: Record<ReviewPlatform, string> = {
  appstore: 'App Store',
  booking: 'Booking.com',
  expedia: 'Expedia',
  google: 'Google Maps',
  playstore: 'Google Play',
  tripadvisor: 'Tripadvisor',
}

// Canonical left-to-right display order for platform tabs, filters and legends.
// Which of these actually render is driven by the data, not this list.
export const PLATFORM_ORDER: ReviewPlatform[] = [
  'google',
  'tripadvisor',
  'booking',
  'expedia',
  'playstore',
  'appstore',
]
